import { z } from 'zod';
import { moneySchema } from '../money';

/** EK oder VK — Dimension der Preis-Historie. */
export const articlePriceTypeSchema = z.enum(['PURCHASE', 'SALES']);
export type ArticlePriceType = z.infer<typeof articlePriceTypeSchema>;

/** Eintrag der Preis-Historie (append-only; geschrieben bei jeder Preisänderung). */
export const priceHistoryEntrySchema = z.object({
  id: z.string().uuid(),
  articleId: z.string().uuid(),
  priceType: articlePriceTypeSchema,
  price: moneySchema,
  recordedAt: z.string().datetime(),
});
export type PriceHistoryEntry = z.infer<typeof priceHistoryEntrySchema>;
